import React from 'react';

import { useTranslation } from 'react-i18next';

import { Button } from '@pkg/components/Sections/Profile/Buttons';
import { Chip, ChipColor, ChipSize } from '@pkg/components/Sections/Profile/Chip';
import { useMembersPanel } from '@pkg/hooks';

import { type SocialGroup } from '@app/gen';

import { YatUsername } from '../../GroupCard';
import { GrowYourPodsPrompt } from '../GrowYourPodsPrompt';

import { AddMembersWrapper, ChipText, Root } from './styles';

type GroupHeaderMembersProps = Pick<SocialGroup, 'members'> & {
    limit?: number;
    groupId?: string;
    showAddMembers?: boolean;
};

export const GroupHeaderMembers = ({
    members,
    limit = 3,
    groupId,
    showAddMembers = false,
    ...others
}: GroupHeaderMembersProps) => {
    const { t: translate } = useTranslation('groups');
    const { openPanel } = useMembersPanel();

    const membersToBeDisplayed = members?.sample.filter((member) => Boolean(member.primary_yat)).slice(0, limit);

    function handleOpenPanel() {
        if (!groupId) return;
        openPanel(groupId);
    }

    return (
        <Root {...others}>
            {membersToBeDisplayed?.map((member) => (
                <YatUsername
                    key={member.id}
                    to={member.primary_yat != null ? `/${member.primary_yat}` : undefined}
                    yat={member.primary_yat}
                    twitter={member.twitter}
                    size={ChipSize.Smaller}
                />
            ))}
            {/* TODO: This should accept a `disabled` prop. */}
            {members?.total && members?.total > limit && (
                <Chip color={ChipColor.Shine} size={ChipSize.Smaller} onClick={handleOpenPanel}>
                    <Chip.Interior>
                        <ChipText>+{members.total - (membersToBeDisplayed ?? []).length}</ChipText>
                    </Chip.Interior>
                </Chip>
            )}
            {/* TODO: Why is this here? It is redundant with the <EmptyChip /> */}
            {showAddMembers && (
                <AddMembersWrapper>
                    <Button
                        variant="solid"
                        color="translucent"
                        size="xsmall"
                        disabled={!groupId}
                        onClick={handleOpenPanel}
                    >
                        {translate('pods_add_members')}
                    </Button>
                    <GrowYourPodsPrompt handleOpenPanel={handleOpenPanel} />
                </AddMembersWrapper>
            )}
        </Root>
    );
};
